import React, { useState, useEffect } from 'react';

// --- Iconos ---
const IconPlus = () => <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20"><path d="M10 3a1 1 0 011 1v5h5a1 1 0 110 2h-5v5a1 1 0 11-2 0v-5H4a1 1 0 110-2h5V4a1 1 0 011-1z"></path></svg>;

// --- Datos para desplegables ---
const countries = ["United States", "Canada", "Mexico", "Venezuela"];
const usStates = ["Alabama", "Alaska", "Arizona", "Arkansas", "California", "Colorado", "Connecticut", "Delaware", "Florida", "Georgia", "Hawaii", "Idaho", "Illinois", "Indiana", "Iowa", "Kansas", "Kentucky", "Louisiana", "Maine", "Maryland", "Massachusetts", "Michigan", "Minnesota", "Mississippi", "Missouri", "Montana", "Nebraska", "Nevada", "New Hampshire", "New Jersey", "New Mexico", "New York", "North Carolina", "North Dakota", "Ohio", "Oklahoma", "Oregon", "Pennsylvania", "Rhode Island", "South Carolina", "South Dakota", "Tennessee", "Texas", "Utah", "Vermont", "Virginia", "Washington", "West Virginia", "Wisconsin", "Wyoming"];

// ============================================================================
// COMPONENTE MODULAR: ClientModal
// ============================================================================
const ClientModal = ({ isOpen, onClose, onSave, clientData }) => {
    const [formData, setFormData] = useState({});

    useEffect(() => {
        const initialFormState = {
            name: clientData?.name || '',
            companyName: clientData?.companyName || '',
            email: clientData?.email || '',
            phone: clientData?.phone || '',
            businessPhone: clientData?.businessPhone || '',
            address_line1: clientData?.address?.line1 || '',
            address_line2: clientData?.address?.line2 || '',
            address_city: clientData?.address?.city || '',
            address_state: clientData?.address?.state || '',
            address_zip: clientData?.address?.zip || '',
            address_country: clientData?.address?.country || 'United States',
            contacts: clientData?.contacts?.length > 0 ? clientData.contacts : [{ name: '', title: '', phone: '', email: '' }]
        };
        setFormData(initialFormState);
    }, [clientData, isOpen]);
    
    const handleChange = (e) => {
        const { name, value } = e.target;
        const newFormData = { ...formData, [name]: value };
        if (name === 'companyName') {
            newFormData.name = value;
        }
        setFormData(newFormData);
    };

    const handleContactChange = (index, e) => {
        const { name, value } = e.target;
        const updatedContacts = [...formData.contacts];
        updatedContacts[index][name] = value;
        setFormData(prev => ({...prev, contacts: updatedContacts}));
    };

    const addContact = () => {
        setFormData(prev => ({...prev, contacts: [...prev.contacts, { name: '', title: '', phone: '', email: '' }]}));
    };

    const removeContact = (index) => {
        if (formData.contacts.length > 1) {
            const updatedContacts = [...formData.contacts];
            updatedContacts.splice(index, 1);
            setFormData(prev => ({...prev, contacts: updatedContacts}));
        }
    };

    const handleSave = () => {
        const dataToSave = {
            name: formData.companyName, // Usamos companyName como el 'name' principal
            companyName: formData.companyName,
            email: formData.email,
            phone: formData.phone,
            businessPhone: formData.businessPhone,
            address: {
                line1: formData.address_line1,
                line2: formData.address_line2,
                city: formData.address_city,
                state: formData.address_state,
                zip: formData.address_zip,
                country: formData.address_country,
            },
            contacts: formData.contacts.filter(c => c.name),
        };
        onSave(dataToSave);
    };

    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
            <div className="bg-white p-6 rounded-lg shadow-xl w-full max-w-3xl max-h-[90vh] overflow-y-auto">
                <h2 className="text-2xl font-bold mb-4">{clientData ? 'Editar Cliente' : 'Nuevo Cliente'}</h2>
                <div className="space-y-6">
                     <fieldset className="border p-4 rounded-md">
                        <legend className="text-lg font-semibold px-2">Información del Cliente</legend>
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-2">
                             <div>
                                <label className="block text-sm font-medium text-gray-700">Nombre de la Compañía</label>
                                <input type="text" name="companyName" value={formData.companyName || ''} onChange={handleChange} className="mt-1 block w-full p-2 border border-gray-300 rounded-md" required/>
                            </div>
                             <div>
                                <label className="block text-sm font-medium text-gray-700">Email</label>
                                <input type="email" name="email" value={formData.email || ''} onChange={handleChange} className="mt-1 block w-full p-2 border border-gray-300 rounded-md"/>
                            </div>
                             <div>
                                <label className="block text-sm font-medium text-gray-700">Teléfono Principal</label>
                                <input type="text" name="phone" value={formData.phone || ''} onChange={handleChange} className="mt-1 block w-full p-2 border border-gray-300 rounded-md"/>
                            </div>
                            <div>
                                <label className="block text-sm font-medium text-gray-700">Teléfono de Negocio</label>
                                <input type="text" name="businessPhone" value={formData.businessPhone || ''} onChange={handleChange} className="mt-1 block w-full p-2 border border-gray-300 rounded-md"/>
                            </div>
                        </div>
                    </fieldset>

                    <fieldset className="border p-4 rounded-md">
                        <legend className="text-lg font-semibold px-2">Dirección</legend>
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-2">
                            <div>
                                <label className="block text-sm font-medium text-gray-700">País</label>
                                <select name="address_country" value={formData.address_country || 'United States'} onChange={handleChange} className="mt-1 block w-full p-2 border border-gray-300 rounded-md">
                                    {countries.map(c => <option key={c} value={c}>{c}</option>)}
                                </select>
                            </div>
                            <div>
                                <label className="block text-sm font-medium text-gray-700">Dirección Línea 1</label>
                                <input type="text" name="address_line1" value={formData.address_line1 || ''} onChange={handleChange} className="mt-1 block w-full p-2 border border-gray-300 rounded-md"/>
                            </div>
                            <div>
                                <label className="block text-sm font-medium text-gray-700">Dirección Línea 2</label>
                                <input type="text" name="address_line2" value={formData.address_line2 || ''} onChange={handleChange} className="mt-1 block w-full p-2 border border-gray-300 rounded-md"/>
                            </div>
                            <div className="grid grid-cols-3 gap-2">
                                <div>
                                    <label className="block text-sm font-medium text-gray-700">Ciudad</label>
                                    <input type="text" name="address_city" value={formData.address_city || ''} onChange={handleChange} className="mt-1 block w-full p-2 border border-gray-300 rounded-md"/>
                                </div>
                                <div>
                                    <label className="block text-sm font-medium text-gray-700">Estado</label>
                                    {formData.address_country === 'United States' ? (
                                        <select name="address_state" value={formData.address_state || ''} onChange={handleChange} className="mt-1 block w-full p-2 border border-gray-300 rounded-md">
                                            <option value="">-- Select State --</option>
                                            {usStates.map(s => <option key={s} value={s}>{s}</option>)}
                                        </select>
                                    ) : (
                                        <input type="text" name="address_state" value={formData.address_state || ''} onChange={handleChange} className="mt-1 block w-full p-2 border border-gray-300 rounded-md" />
                                    )}
                                </div>
                                <div>
                                    <label className="block text-sm font-medium text-gray-700">ZIP</label>
                                    <input type="text" name="address_zip" value={formData.address_zip || ''} onChange={handleChange} className="mt-1 block w-full p-2 border border-gray-300 rounded-md"/>
                                </div>
                            </div>
                        </div>
                    </fieldset>

                    <fieldset className="border p-4 rounded-md">
                        <legend className="text-lg font-semibold px-2">Contactos</legend>
                        <div className="space-y-4 mt-2">
                            {(formData.contacts || []).map((contact, index) => (
                                <div key={index} className="p-3 border rounded-md bg-gray-50 relative">
                                    {formData.contacts.length > 1 && (
                                        <button type="button" onClick={() => removeContact(index)} className="absolute -top-2 -right-2 bg-red-500 text-white rounded-full w-6 h-6 flex items-center justify-center">&times;</button>
                                    )}
                                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                        <input type="text" name="name" value={contact.name} onChange={(e) => handleContactChange(index, e)} placeholder="Nombre completo" className="w-full p-2 border border-gray-300 rounded-md" />
                                        <input type="text" name="title" value={contact.title} onChange={(e) => handleContactChange(index, e)} placeholder="Cargo" className="w-full p-2 border border-gray-300 rounded-md" />
                                        <input type="text" name="phone" value={contact.phone} onChange={(e) => handleContactChange(index, e)} placeholder="Teléfono" className="w-full p-2 border border-gray-300 rounded-md" />
                                        <input type="email" name="email" value={contact.email} onChange={(e) => handleContactChange(index, e)} placeholder="Email" className="w-full p-2 border border-gray-300 rounded-md" />
                                    </div>
                                </div>
                            ))}
                        </div>
                        <button type="button" onClick={addContact} className="mt-4 text-sm text-blue-600 hover:text-blue-800 flex items-center gap-1">
                            <IconPlus /> Añadir Contacto
                        </button>
                    </fieldset>
                </div>
                <div className="flex justify-end gap-4 mt-6">
                    <button type="button" onClick={onClose} className="px-4 py-2 text-sm font-medium text-gray-700 bg-gray-200 rounded-md hover:bg-gray-300">Cancelar</button>
                    <button type="button" onClick={handleSave} className="px-4 py-2 text-sm font-medium text-white bg-blue-600 rounded-md hover:bg-blue-700">Guardar Cliente</button>
                </div>
            </div>
        </div>
    );
};

export default ClientModal;
